
















































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {Izdatnica, Trebovanje} from "@/services/BackendProxies";
import TableEditorsMixin from '@/mixins/table-editors.mixin';
import {mixins} from "vue-class-component";
import dataProxy from '@/services/data-proxy.service';
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";


@Component({})
export default class IzdatnicaComponent extends mixins(TableEditorsMixin, ComponentBaseMixin) {

    izdatnica = Izdatnica.fromJS({datum: new Date(), delovi: []});
    brojRadnogNaloga = '';
    columns = [];
    options = {
        pagination: false,
    };
    radniNalog = '';
    vueFormatters = [];
    isBusy = false;

    async created() {
        this.columns = [
            {field: 'rezervniDeo', title: this.$i18n.t('rezervniDeo')},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), width: 100, align: 'right'},
            {field: 'utroseno', title: this.$i18n.t('izdataKolicina'), formatter: this.izdataKolicinaFormatter, width: 100, align: 'right'},
        ]
    }

    async sacuvajIzdatnicu() {
        if (this.isBusy) return;
        const isValidForm = await (<any>this.$refs.form).validate();
        if (isValidForm) {
            try {
                this.isBusy = true;
                this.izdatnica = await this.saveData(() => dataProxy.sacuvajIzdatnicu(this.izdatnica))();
            } finally {
                this.isBusy = false;
            }
        }
    }

    kreirajNovu() {
        this.izdatnica = Izdatnica.fromJS({datum: new Date(), delovi: []});
        this.radniNalog = '';
        this.brojRadnogNaloga = '';
    }

    async zakljuciDokument() {
        if (this.isBusy) return;
        const da = await this.confirmationNeeded('da li zelite da zakljucite izdatnicu');
        if (da) {
            try {
                this.isBusy = true;
                this.izdatnica = await this.saveData(() => dataProxy.zakljuciIzdatnicu(this.izdatnica))();
                this.kreirajNovu();
            } finally {
                this.isBusy = false;
            }
        }
    }

    async onUnetBrojTrebovanja(id: number) {
        if (id) {
            const trebovanje = await dataProxy.vratiTrebovanjePoId(id);
            this.izdatnica = Izdatnica.fromJS({
                trebovanjeId: trebovanje.id,
                skladisteId: trebovanje.skladisteId,
                delovi: trebovanje.stavke.map(x => ({
                    rezervniDeoId: x.rezervniDeoId,
                    rezervniDeo: x.rezervniDeo,
                    kolicina: x.kolicina}))
            });
            this.radniNalog = trebovanje.radniNalog;
        }
    }

    async onUnetBrojIzdatnice(id: number) {
        if (id) {
            this.izdatnica = await dataProxy.vratiIzdatnicuPoId(id);
            this.radniNalog = this.izdatnica.radniNalog;
            //this.brojRadnogNaloga = '';
        }
    }

    izdataKolicinaFormatter(value, row) {
        return this.vueFormatter({
            template: `
                <input type="number" v-model="row.utrosenaKolicina" class="form-control text-right"
                       :class="{invalid: row.utrosenaKolicina === undefined || row.utrosenaKolicina > row.kolicina || row.utrosenaKolicina < 0}"/>
            `,
            data: { row },
        })
    }
}
